<template>
  <div ref="sceneViewMarkerSelecting" class="sceneViewMarkerSelecting alibabaPuHuiTiFontFamily">
    <img src="../../../assets/globe/scene/viewPoint/viewPointMapIcon_selecting.png"
         :style="{'animation-name':animationName,'animation-duration':animationDuration}"
         style="position:relative;top:0;left:0;width:100%;">

    <img src="../../../assets/globe/scene/viewPoint/viewPointMapIcon_selecting_circle.png" style="position:absolute;bottom:0;left:0;width:100%;">
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "SceneViewMarkerSelecting",
  props:["markerInfo","markerIndex"],
  data() {
    return {
      marker: '',

      animationName:"",
      animationDuration:"500ms",
    }
  },
  mounted() {
    this.marker = new mapboxgl.Marker(this.$refs.sceneViewMarkerSelecting)
        .setLngLat(this.markerInfo.center)
        .addTo(this.$parent.$parent.map)

    //跟随地图移动改变位置
    this.$parent.$parent.map.on('move',()=>{
      this.marker.setLngLat(this.$parent.$parent.map.getCenter())
    })
    this.$parent.$parent.map.on('moveend',()=>{
      this.animationName = "sceneViewMarkerSelectingJump"
      setTimeout(()=>{
        this.animationName = ""
      },500)
    })


  },
  destroyed() {
    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.sceneViewMarkerSelecting{
  position:absolute;
  width:42px;
  height:70px;
}



</style>

<style>
@keyframes sceneViewMarkerSelectingJump {
  from {top:0}
  50% {top:-4px;}
  to {top:0}
}
</style>